import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import { useRuntimeConfig } from '@/hooks/useRuntimeConfig';
import { CustomazibleWordingReplaceMapping } from '@/types/system.type';

export function useLevvelTranslation() {
  const [t] = useTranslation();
  const config = useRuntimeConfig();
  const word = config?.style?.wording;

  const lt = (text: string, option?: any) => {
    let result = t(text, { ...option });
    const keysValue = result.match(/(?<=\{\{)(.+?)(?=\})/g);

    if (keysValue?.length && word) {
      result = render(result, word);
    }

    return result;
  };

  return { lt };
}

function render(template: string, context: CustomazibleWordingReplaceMapping) {
  return template.replace(/\{\{(.*?)\}\}/g, (match, key) =>
    context[key.trim()] ? context[key.trim()][i18n.language] : `{${key}}`
  );
}
